module.exports = __webpack_public_path__ + "static/media/OurCompany2-FR.2af10d63.png";